<template>
    <v-form v-model="valid">
        <v-autocomplete :label='$t("labelClubAcademy")' :items="listOfClubsAndAcademies" item-text="name" item-value="id" v-model="clubOrAcademyChoosed" @change="retrieveStrategies" outlined/>
        <v-autocomplete :label='$t("labelStrategy")' :rules="strategyRule" :items="strategies" item-text="name" item-value="id" v-model="strategyChoosed" outlined/>
        <v-btn :disabled="!valid" @click="addStrategy">{{ $t('addStrategy_SearchStrategy') }}</v-btn>
    </v-form>
</template>

<script>
    import ClubRepository from '../../repositories/club';
    import StrategyRepository from '../../repositories/strategy';
    import { mapMutations } from 'vuex';
    export default {
        name: "SearchStrategy",
        data() {
            return {
                // Data
                listOfClubsAndAcademies: [],
                strategies: [],
                clubOrAcademyChoosed: '',
                strategyChoosed: '',

                // Rules
                valid: false,
                strategyRule: [
                    s => !!s || this.$t('watchlistNameRequired'),
                ],
            };
        },
        mounted() {
            this.loadClubsAcademies();
        },
        methods: {
            loadClubsAcademies() {
                ClubRepository.allClubs().then((response) => {
                    if(response.status < 400) {
                        this.listOfClubsAndAcademies = response.data;
                    }
                });
            },
            ...mapMutations(['setStrategies']),
            addStrategy() {
                if(this.valid){
                    StrategyRepository.addStrategy(this.strategyChoosed).then(async (response) => {
                        if(response.status < 400) {
                            await StrategyRepository.allStrategiesOfUser().then((responseRetrieving) => {
                                this.setStrategies(responseRetrieving.data);
                            });
                            this.$emit('closeWindow');
                        }
                    })
                }else
                    alert(this.$t('pleaseAddStrategy'));
            },
            retrieveStrategies() {
                StrategyRepository.findStrategiesOfClub(this.clubOrAcademyChoosed).then((response) => {
                    if(response.status < 400) {
                        this.strategies = response.data;
                    }
                });
            }
        },
    }
</script>

<style scoped>

</style>


